<template>
  <div v-if="notes">
    <form @submit.prevent="addNote">
      <b-table-simple striped bordered>
        <b-tbody>
          <b-tr>
            <th>Note</th>
            <th>By</th>
            <th>At</th>
          </b-tr>
          <b-tr v-for="(note, index) in notes" :key="index">
            <b-td :class="` pt-3 `">
              {{ note.text }}
            </b-td>
            <b-td>
              {{ note.by }}
            </b-td>
            <b-td>
              {{ note.at }}
            </b-td>
            <b-td>
              <b-button
                type="button"
                @click="() => deleteNote(index)"
                variant="danger"
                size="sm"
              >
                <i class="las la-trash fa-lg"></i>
              </b-button>
            </b-td>
          </b-tr>
          <b-tr>
            <b-td>
              <b-textarea v-model="note" class="form-control px-3"></b-textarea>
            </b-td>
            <b-td colspan="8" style="text-align: left;">
              <b-button
                type="submit"
                @click="addNote"
                class=" btn-success mt-3"
                :disabled="note === ''"
                > <i class="fa fa-plus"></i> Add
              </b-button>
            </b-td>
          </b-tr>
        </b-tbody>
      </b-table-simple>
    </form>
  </div>
</template>

<style scoped></style>
<script>
import moment from "moment";
export default {
  name: "NotesList",
  props: ["notesData"],
  data() {
    return {
      note: "",
      notes: [],
      noteModel: {
        text: "",
        by: "",
        at: null
      },
      emptyNote: ""
    };
  },
  mounted() {
    this.notes = this.notesData || [];
    this.emptyNote = JSON.stringify(this.noteModel);
  },
  methods: {
    addNote() {
      let newNote = JSON.parse(this.emptyNote);
      newNote.text = this.note;
      newNote.by = this.$store.state.User.user.name;
      newNote.at = moment().format("YYYY-MM-DD hh:mm a");
      this.notes.push(newNote);
      this.note = "";
    },
    deleteNote(index) {
      this.notes.splice(index, 1);
    }
  },
  watch: {
    notesData: {
      deep: true,
      handler(value) {
        this.notes = value || [];
      }
    },
    notes: {
      deep: true,
      handler(value) {
        this.$emit("updateNotes", value);
      }
    }
  }
};
</script>
